if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        mobileSlider: this.querySelector('.slider--mobile.showOnlyMobile')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      this.sliderVisible = false;

      this.setupMobileVideoAutoplay();
      this._onResetMediaGalleryVideo = () => {
        this.setupMobileVideoAutoplay();
        this.playFirstVisibleVideoSlide();
      };
      document.addEventListener('reset-media-gallery-video', this._onResetMediaGalleryVideo);

     
    }

    setupMobileVideoAutoplay() {
      if (!this.elements.mobileSlider) return;

      // purana observer hatado
      if (this.mobileVideoObserver) this.mobileVideoObserver.disconnect();

      const slides = Array.from(this.elements.mobileSlider.querySelectorAll('[data-media-id]'));

      this.mobileVideoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.65) return;

          // variant filter me LI pe style="display:none" lagta hai
          if (getComputedStyle(entry.target).display === 'none') return;

          // sirf video/deferred-media wale slides pe play call
          if (!entry.target.querySelector('.deferred-media')) return;

          if (entry.target.getAttribute('data-user-paused') === 'true') return;

          this.playActiveMedia(entry.target);
        });
      }, { threshold: [0, 0.65, 1] });

      slides.forEach((slide) => {
        if (slide.querySelector('.deferred-media')) {
          this.mobileVideoObserver.observe(slide);
        }
      });
    }

    playFirstVisibleVideoSlide() {
      if (!this.elements.mobileSlider) return;

      const firstVisible = Array.from(this.elements.mobileSlider.querySelectorAll('[data-media-id]'))
        .find((slide) => getComputedStyle(slide).display !== 'none' && slide.querySelector('.deferred-media'));

      if (firstVisible) this.playActiveMedia(firstVisible);
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();

      if (activeItem.getAttribute('data-user-paused') === 'true') return;

      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }


    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    disconnectedCallback() {
      if (this.mobileVideoObserver) this.mobileVideoObserver.disconnect();
      if (this._onResetMediaGalleryVideo) {
        document.removeEventListener('reset-media-gallery-video', this._onResetMediaGalleryVideo);
      }
    }

  });
}
